import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { fonts } from "../../themes/theme";
import logo from "../../assets/logo-white.svg";

/**
 * Marca del panel: el nombre de la clínica es el protagonista y Mential aparece
 * como proveedor ("by" + logo) debajo, en pequeño. Reutilizado en el sidebar
 * (desktop) y en la barra superior (móvil). `size` ajusta la escala.
 */
function BrandMark({ onClick, size = "md", name }) {
    const { t } = useTranslation();
    // `name` = override en vivo (p.ej. selección del login). Si no, la org
    // guardada al iniciar sesión; si tampoco, el placeholder "Clínica".
    const stored = (typeof window !== "undefined" && sessionStorage.getItem("demoOrg")) || "";
    const title = name || stored || t("sidebar.brandTitle");
    const long = title.length > 14;
    const titleSize = size === "lg" ? (long ? 34 : 42) : size === "sm" ? (long ? 15 : 19) : (long ? 18 : 23);
    const logoH = size === "lg" ? 26 : size === "sm" ? 12 : 14;
    const bySize = size === "lg" ? 13 : 9.5;

    return (
        <Box
            onClick={onClick}
            sx={{
                display: "flex",
                flexDirection: "column",
                lineHeight: 1,
                cursor: onClick ? "pointer" : "default",
                minWidth: 0,
            }}
        >
            <Typography sx={{ fontFamily: fonts.display, fontWeight: 400, fontSize: titleSize, color: "#fff", lineHeight: 1.05 }}>
                {title}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.45 }}>
                <Typography sx={{ fontSize: bySize, color: "rgba(255,255,255,0.55)", lineHeight: 1 }}>
                    {t("sidebar.brandBy")}
                </Typography>
                <Box component="img" src={logo} alt="Mential" sx={{ height: logoH, width: "auto", display: "block" }} />
            </Box>
        </Box>
    );
}

export default BrandMark;
